import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';

export function UsageRangeWarning({ onDismiss }: { onDismiss: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="flex items-start justify-between gap-2.5 rounded-lg border border-warning/15 bg-warning-background px-3 py-2.5 dark:border-warning/25">
      <div className="space-y-1">
        <p className="text-xs font-medium text-warning-high-emphasis">{t('DATE_RANGE_MAX_DAYS')}</p>
        <p className="text-xs leading-5 text-warning-high-emphasis/90">{t('DATE_RANGE_MAX_DAYS_BODY')}</p>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 shrink-0 rounded-md text-warning-high-emphasis hover:bg-warning/10 hover:text-warning-high-emphasis"
        onClick={onDismiss}
        aria-label={t('DISMISS_ANALYTICS_NOTICE')}
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
